/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var common_pb = require('./common_pb.js');
var route_proposal_pb = require('./route_proposal_pb.js');
goog.exportSymbol('proto.ori.telecomms.proto.RoutePlanError', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RoutePlanError.ErrorCode', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RoutePlanRequest', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RoutePlanResponse', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RoutePlanSuccess', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.StationType', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RoutePlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.RoutePlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RoutePlanRequest.displayName = 'proto.ori.telecomms.proto.RoutePlanRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RoutePlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RoutePlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    route: (f = msg.getRoute()) && common_pb.WaypointList.toObject(includeInstance, f),
    terminus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RoutePlanRequest}
 */
proto.ori.telecomms.proto.RoutePlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RoutePlanRequest;
  return proto.ori.telecomms.proto.RoutePlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RoutePlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RoutePlanRequest}
 */
proto.ori.telecomms.proto.RoutePlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.WaypointList;
      reader.readMessage(value,common_pb.WaypointList.deserializeBinaryFromReader);
      msg.setRoute(value);
      break;
    case 2:
      var value = /** @type {!proto.ori.telecomms.proto.StationType} */ (reader.readEnum());
      msg.setTerminus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RoutePlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RoutePlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoute();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.WaypointList.serializeBinaryToWriter
    );
  }
  f = message.getTerminus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional WaypointList route = 1;
 * @return {?proto.ori.telecomms.proto.WaypointList}
 */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.getRoute = function() {
  return /** @type{?proto.ori.telecomms.proto.WaypointList} */ (
    jspb.Message.getWrapperField(this, common_pb.WaypointList, 1));
};


/** @param {?proto.ori.telecomms.proto.WaypointList|undefined} value */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.setRoute = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.ori.telecomms.proto.RoutePlanRequest.prototype.clearRoute = function() {
  this.setRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.hasRoute = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StationType terminus = 2;
 * @return {!proto.ori.telecomms.proto.StationType}
 */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.getTerminus = function() {
  return /** @type {!proto.ori.telecomms.proto.StationType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.ori.telecomms.proto.StationType} value */
proto.ori.telecomms.proto.RoutePlanRequest.prototype.setTerminus = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RoutePlanError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.RoutePlanError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RoutePlanError.displayName = 'proto.ori.telecomms.proto.RoutePlanError';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RoutePlanError.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RoutePlanError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RoutePlanError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanError.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorcode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RoutePlanError}
 */
proto.ori.telecomms.proto.RoutePlanError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RoutePlanError;
  return proto.ori.telecomms.proto.RoutePlanError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RoutePlanError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RoutePlanError}
 */
proto.ori.telecomms.proto.RoutePlanError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ori.telecomms.proto.RoutePlanError.ErrorCode} */ (reader.readEnum());
      msg.setErrorcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RoutePlanError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RoutePlanError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RoutePlanError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.RoutePlanError.ErrorCode = {
  UNKNOWN: 0,
  INVALID_REQUEST: 1,
  UNKNOWN_OPAREA: 2,
  PROPOSAL_EXPECTED: 3,
  INVALID_ROUTE: 4
};

/**
 * optional ErrorCode errorCode = 1;
 * @return {!proto.ori.telecomms.proto.RoutePlanError.ErrorCode}
 */
proto.ori.telecomms.proto.RoutePlanError.prototype.getErrorcode = function() {
  return /** @type {!proto.ori.telecomms.proto.RoutePlanError.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.ori.telecomms.proto.RoutePlanError.ErrorCode} value */
proto.ori.telecomms.proto.RoutePlanError.prototype.setErrorcode = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RoutePlanSuccess = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.RoutePlanSuccess, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RoutePlanSuccess.displayName = 'proto.ori.telecomms.proto.RoutePlanSuccess';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RoutePlanSuccess.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RoutePlanSuccess} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanSuccess.toObject = function(includeInstance, msg) {
  var f, obj = {
    cmdheader: (f = msg.getCmdheader()) && common_pb.ControlCommandHeader.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RoutePlanSuccess}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RoutePlanSuccess;
  return proto.ori.telecomms.proto.RoutePlanSuccess.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RoutePlanSuccess} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RoutePlanSuccess}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.ControlCommandHeader;
      reader.readMessage(value,common_pb.ControlCommandHeader.deserializeBinaryFromReader);
      msg.setCmdheader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RoutePlanSuccess.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RoutePlanSuccess} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanSuccess.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCmdheader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.ControlCommandHeader.serializeBinaryToWriter
    );
  }
};


/**
 * optional ControlCommandHeader cmdHeader = 1;
 * @return {?proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.prototype.getCmdheader = function() {
  return /** @type{?proto.ori.telecomms.proto.ControlCommandHeader} */ (
    jspb.Message.getWrapperField(this, common_pb.ControlCommandHeader, 1));
};


/** @param {?proto.ori.telecomms.proto.ControlCommandHeader|undefined} value */
proto.ori.telecomms.proto.RoutePlanSuccess.prototype.setCmdheader = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.ori.telecomms.proto.RoutePlanSuccess.prototype.clearCmdheader = function() {
  this.setCmdheader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RoutePlanSuccess.prototype.hasCmdheader = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RoutePlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_);
};
goog.inherits(proto.ori.telecomms.proto.RoutePlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RoutePlanResponse.displayName = 'proto.ori.telecomms.proto.RoutePlanResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.ori.telecomms.proto.RoutePlanResponse.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  ERROR: 1,
  SUCCESS: 2,
  PROPOSAL: 3
};

/**
 * @return {proto.ori.telecomms.proto.RoutePlanResponse.ResponseCase}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.getResponseCase = function() {
  return /** @type {proto.ori.telecomms.proto.RoutePlanResponse.ResponseCase} */(jspb.Message.computeOneofCase(this, proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RoutePlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RoutePlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && proto.ori.telecomms.proto.RoutePlanError.toObject(includeInstance, f),
    success: (f = msg.getSuccess()) && proto.ori.telecomms.proto.RoutePlanSuccess.toObject(includeInstance, f),
    proposal: (f = msg.getProposal()) && route_proposal_pb.RouteProposal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RoutePlanResponse}
 */
proto.ori.telecomms.proto.RoutePlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RoutePlanResponse;
  return proto.ori.telecomms.proto.RoutePlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RoutePlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RoutePlanResponse}
 */
proto.ori.telecomms.proto.RoutePlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ori.telecomms.proto.RoutePlanError;
      reader.readMessage(value,proto.ori.telecomms.proto.RoutePlanError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 2:
      var value = new proto.ori.telecomms.proto.RoutePlanSuccess;
      reader.readMessage(value,proto.ori.telecomms.proto.RoutePlanSuccess.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 3:
      var value = new route_proposal_pb.RouteProposal;
      reader.readMessage(value,route_proposal_pb.RouteProposal.deserializeBinaryFromReader);
      msg.setProposal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RoutePlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RoutePlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RoutePlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ori.telecomms.proto.RoutePlanError.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ori.telecomms.proto.RoutePlanSuccess.serializeBinaryToWriter
    );
  }
  f = message.getProposal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      route_proposal_pb.RouteProposal.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoutePlanError error = 1;
 * @return {?proto.ori.telecomms.proto.RoutePlanError}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.getError = function() {
  return /** @type{?proto.ori.telecomms.proto.RoutePlanError} */ (
    jspb.Message.getWrapperField(this, proto.ori.telecomms.proto.RoutePlanError, 1));
};


/** @param {?proto.ori.telecomms.proto.RoutePlanError|undefined} value */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_[0], value);
};


proto.ori.telecomms.proto.RoutePlanResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RoutePlanSuccess success = 2;
 * @return {?proto.ori.telecomms.proto.RoutePlanSuccess}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ori.telecomms.proto.RoutePlanSuccess} */ (
    jspb.Message.getWrapperField(this, proto.ori.telecomms.proto.RoutePlanSuccess, 2));
};


/** @param {?proto.ori.telecomms.proto.RoutePlanSuccess|undefined} value */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.setSuccess = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_[0], value);
};


proto.ori.telecomms.proto.RoutePlanResponse.prototype.clearSuccess = function() {
  this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RouteProposal proposal = 3;
 * @return {?proto.ori.telecomms.proto.RouteProposal}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.getProposal = function() {
  return /** @type{?proto.ori.telecomms.proto.RouteProposal} */ (
    jspb.Message.getWrapperField(this, route_proposal_pb.RouteProposal, 3));
};


/** @param {?proto.ori.telecomms.proto.RouteProposal|undefined} value */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.setProposal = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.ori.telecomms.proto.RoutePlanResponse.oneofGroups_[0], value);
};


proto.ori.telecomms.proto.RoutePlanResponse.prototype.clearProposal = function() {
  this.setProposal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RoutePlanResponse.prototype.hasProposal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.StationType = {
  UNKNOWN: 0,
  NONE: 1,
  PICKUP: 2,
  DROPOFF: 3
};

goog.object.extend(exports, proto.ori.telecomms.proto);
